/* global process */
let base = window._env_.VUE_APP_ADMIN_HOST
export const queryMarketCsLocationLog = params => {
  return axios.post(`${base}/market-cs-location-log/query`, params)
}



// WEBPACK FOOTER //
// ./src/views/market/market-cs-location-log.api.js